module.exports = __webpack_public_path__ + "static/media/providePlatform.8813924c.png";